import React from "react";
import Modal from "react-modal";

import "./Modal.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    borderRadius: "2px",
    border: "none"
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0, 0.5)"
  }
};

class TeamMember extends React.Component {
  constructor() {
    super();

    this.state = {
      modal: false
    };
  }

  componentDidUpdate() {
    if (this.state.modal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }

  openModal = () => {
    this.setState({
      modal: true
    });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  render() {
    const { member } = this.props;

    return (
      <div className="col-sm-6">
        <div className="portfolio-item" id="john_lavalley">
          <a
            href="#"
            onClick={event => {
              event.preventDefault();
              this.openModal();
            }}
          >
            <h3>{member.name}</h3>
            <p>{member.title}</p>
          </a>
          <Modal
            isOpen={this.state.modal}
            // onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div className="modal-dialog" role="document">
              <div className="react-modal-content">
                <div className="modal-header">
                  <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="react-modal-body">
                  <div className="react-modal-team-name">
                    <h2>{member.name}</h2>
                  </div>
                  <div className="react-modal-team-role">
                    <h5>{member.title}</h5>
                  </div>
                  <div className="react-modal-team-description">
                    <p>{member.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default TeamMember;
